// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2PTam","productName":"Table_productName__3ETJM"};